export interface TimelineFeatures {
    helpMeNowQuestion: string;
    isChatExpertAssistAutoCompleteEnabled: boolean;
    isChatProactiveSuggestionsEnabled: boolean;
    isGuidedFlowRecommendationEnabled: boolean;
    isHelpMeNowEnabled: boolean;
    isOzmoIFrameEnabled: boolean;
    isProactiveEnabled: boolean;
    isReactiveCallContextV2Enabled: boolean;
    isSalesFAQEnabled: boolean;
    proactiveSuggestionInterval: number;
}

export const defaultHelpMeNowQuestion = "Help the customer with their technical problem";
export const defaultProactiveSuggestionInterval = 60000;

export interface WorkspaceFeatures {
    // Note: Some flags use name mapping (see FLAG_NAME_MAP in useFlags.tsx)
    customFlowSystemId?: string;
    includesSendToPartnerMeta: boolean;
    isAutoSummaryEnabled: boolean;
    isChallengeEnabled: boolean; // Maps to "Sales-isChallengeEnabled"
    isChatIssueSummaryEnabled: boolean;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGaiaMultiStepSummaryEnabled: boolean; // Maps to "isGaiaMultiStepSummaryEnabled"
    isGuidedFlowRecommendationEnabled: boolean;
    isPreviousSessionSummaryEnabled: boolean;
    isProactiveEnabled: boolean;
    isRapportEnabled: boolean;
    isChecklistSummaryEnabled: boolean;
    isVerizonCareEnabled: boolean;
    isLightModeEnabled?: boolean;
    isGaiaCallResolutionEnabled: boolean;
    isDynamicSmartOfferEnabled: boolean;
    isMicroLearningV2Enabled: boolean;
    logoutPendingDuration: number;
    isTrainingFeedbackEnabled: boolean;
    isUpdatedEndSessionFlowEnabled: boolean;
    sendSummaryFromBackend: boolean;
    useMdnForAccountNo: boolean;
    isPacingEnabled: boolean;
    isUsingMovedDiscoveryAndEngagementQuestions: boolean; // Maps to "Sales-isUsingMovedDiscoveryAndEngagementQuestions"
    isUpdatedCustomerHandoffEnabled: boolean;
    isMorningPaperEnabled: boolean;
}

export type TimelineContextType = Record<keyof TimelineFeatures, boolean | number | string>;
export type WorkspaceContextType = Record<keyof WorkspaceFeatures, boolean | number | string | undefined>;

// group name used for analytics
export type Group = "Timeline" | "Workspace";
